import React, { useState, useEffect, useRef, useCallback } from "react";
import BusinessDataService from "../services/BusinessService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const BusinessList = (props) => {
  const [business, setBusiness] = useState([]);
  const businessRef = useRef();
  businessRef.current = business;

  let { owner } = useParams();

  const retrieveBusiness = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    BusinessDataService.getAll(target)
      .then((response) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.business ?? payload;
        setBusiness(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("BusinessList.retrieveBusiness error:", e?.response?.status, e?.response?.data || e?.message || e);
        setBusiness([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveBusiness();
  }, [retrieveBusiness]);

  const deleteBusiness = useCallback((rowIndex) => {
    const id = businessRef.current[rowIndex].id || businessRef.current[rowIndex]._id;
    BusinessDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/business");
        const newRows = [...businessRef.current];
        newRows.splice(rowIndex, 1);
        setBusiness(newRows);
      })
      .catch((e) => {
        console.error("deleteBusiness error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/business/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/business/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = businessRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteBusiness(idx);
  }, [deleteBusiness]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          accountType="business"
          transactions={business}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/business/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Business Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default BusinessList;
